import { Skeleton, Stack, Grid } from '@mui/material';

const OverViewLoading = () => {
  return (
    <Grid container spacing={10} py={10} minWidth={500}>
      <Grid item xs={12} md={12}>
        <Skeleton variant="rectangular" height={200} />
      </Grid>
      <Grid item xs={12} md={12}>
        <Stack spacing={2}>
          <Skeleton variant="rectangular" height={20} />
          <Skeleton variant="rectangular" height={20} />
        </Stack>
      </Grid>
      <Grid item xs={12} md={8}></Grid>
      <Grid item xs={12} md={4}>
        <Stack spacing={2}>
          <Skeleton variant="rectangular" height={20} />
          <Skeleton variant="rectangular" height={20} />
          <Skeleton variant="rectangular" height={20} />
        </Stack>
      </Grid>
    </Grid>
  );
};

export default OverViewLoading;
